import { SignClientTypes } from '@reown/web-wallet-core'
import { handleRedirectAndClose } from '@reown/web-wallet-core/src/utils/Redirect'

import { AppLogo } from '../AppLogo'
import Spacer from '../Spacer'

export function ErrorContent({
  title,
  peerMetadata
}: {
  title?: string
  peerMetadata?: SignClientTypes.Metadata
}) {
  const handleRedirect = () => {
    handleRedirectAndClose(peerMetadata)
  }

  return (
    <>
      <AppLogo logoUrl={peerMetadata?.icons?.[0]} status="error" />
      <Spacer size="2" />
      <wui-text variant="lg-medium" color="primary" align="center">
        {title || 'Connection failed'}
      </wui-text>
      <Spacer size="2" />
      <wui-button size="lg" fullWidth variant="neutral-secondary" onClick={handleRedirect}>
        Back to {peerMetadata?.name ?? 'the app'}
        <wui-icon size="sm" color="inherit" slot="iconRight" name="externalLink" />
      </wui-button>
    </>
  )
}
